module.exports = __webpack_public_path__ + "img/face-detector-screenshot.5a820659.png";